let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    jQuery('.header .hamburger').trigger('click')

})

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    if (jQuery(this).hasClass('is-active')) {
        jQuery('.drawer').attr('tabindex', '-1')
    } else {
        jQuery('.drawer').attr('tabindex', '1').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

})

jQuery(document).on('keydown', function(event) {
    if (event.key == "Escape") {

        if( jQuery('body').hasClass('is-drawer') ){

            if (jQuery('.hamburger-toggle .hamburger').hasClass('is-active'))
                jQuery('.drawer').attr('tabindex', '-1')
            else
                jQuery('.drawer').attr('tabindex', '1').focus()

            jQuery('body').toggleClass('is-drawer')
            jQuery('.hamburger').toggleClass('is-active')

        }
    }
});

document.addEventListener('keyup', function(e) {
    if (e.keyCode == 27 && jQuery('body').hasClass('is-drawer')) {
        jQuery('body').toggleClass('is-drawer')
        jQuery('.hamburger').toggleClass('is-active')
    }

    if (e.keyCode == 9 && jQuery('body').hasClass('is-drawer')) {

        var container = jQuery("#drawer");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            jQuery('body').toggleClass('is-drawer')
            jQuery('.hamburger').toggleClass('is-active')

        }

    }
});

function esc_menu(e) {
    if ( e.keyCode === 27 ) {
        if (jQuery('.hamburger').hasClass('is-active')) {
            jQuery('.hamburger').click();
        }
    }
}

jQuery(document).ready(function() {
    jQuery('body').on('keydown', function(e){ esc_menu( e ) } ) ;
});

jQuery(window).on('scroll', function () {
    if (jQuery(window).scrollTop() > 0) {
        header.addClass('header--white')
    } else {
        header.removeClass('header--white')
    }
})

jQuery(document).ready(function () {
    if (jQuery(window).scrollTop() > 0) {
        header.addClass('header--white')
    } else {
        header.removeClass('header--white')
    }
})

jQuery('.drawer__nav .toggle').on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        jQuery('.drawer__nav .open').removeClass('open').next().slideToggle()
        parentEl.toggleClass('open').next().slideToggle()
    }

})
